/**
 * 🏆 Leaderboards Page wrapper — includes Header + Footer + auth guard.
 * The interactive board lives in `<Leaderboards />` — this file is just
 * the shell that plugs into the router at `/leaderboards`.
 */
import { useAuth } from "@/contexts/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Leaderboards from "@/components/Leaderboards";

export default function LeaderboardsPage() {
  const { user, loading } = useAuth();

  if (loading) return null;
  if (!user) {
    return (
      <div className="min-h-screen bg-black text-white">
        <Header />
        <div className="max-w-2xl mx-auto px-4 py-24 text-center">
          <h1 className="font-display text-3xl mb-3">🏆 Leaderboards</h1>
          <p className="text-neutral-400 mb-6">
            Sign in to see the global rankings and pin your row on the board.
          </p>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <>
      <Header />
      <Leaderboards />
      <Footer />
    </>
  );
}
